module.exports = __webpack_public_path__ + "static/4-41967f8260cc16370323d4b60dd2dd9c.jpeg";